import { CardBenefitsComponents as Components } from '../components'
import { View, Text } from 'react-native'
import { Button } from '@/src/common/components/Button'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'
import {
  BenefitModal,
  useIsBenefitScreenPresentedAsModal,
} from '@/src/experiences/card-benefits/components/BenefitModal'
import { mesaColorNames, fontFamilies } from '@/src/common/theme'
import { Check } from '@/src/assets/icons/Check'
import { INSTACART_PARTNER_NAME } from '../constants'
import { useLogError } from '@/src/common/hooks/useLogError'
import { useEffect, useState } from 'react'
import { INSTACART_ENROLLMENT_BENEFIT } from './instacart-enrollment-benefit'
import { useBenefitEnroll } from '../hooks/useBenefitEnroll'
import * as Stores from '../stores'

const selectedBenefit = INSTACART_ENROLLMENT_BENEFIT

export const InstacartEnrollment = () => {
  const onError = useLogError()
  const [instacartUrl, setInstacartUrl] = useState<string | null>(null)
  const benefitName = INSTACART_PARTNER_NAME

  // Enroll user in the Instacart benefit
  const [enrollInBenefit] = useBenefitEnroll()

  // Get the unique Instacart URL for this user
  const [instacartBenefitUrl, instacartBenefitUrlResult] =
    Stores.CardBenefitsApi.endpoints['POST /benefits/instacart/get-url'].useMutation()

  const handleEnrollInstacartBenefit = async () => {
    try {
      const { data } = await instacartBenefitUrl({})
      if (data?.url) {
        setInstacartUrl(data.url)
        // Also enroll the user in the benefit
        void enrollInBenefit({ params: { benefitName } })
      } else {
        onError(new Error('Failed to enroll in Instacart benefit'))
      }
    } catch (err) {
      onError(err)
    }
  }
  // Call the mutation when component mounts to get the URL
  useEffect(() => {
    void handleEnrollInstacartBenefit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()

  const handleGetInstacartPress = () => {
    if (!instacartUrl) return
    void openInAppBrowser(instacartUrl, 'Instacart+')
  }

  return (
    <BenefitModal screenName={'instacart-enrollment'}>
      <Components.Container>
        <Components.Header title={selectedBenefit.header} screenName={'instacart-enrollment'} />
        <Components.Scroll>
          <Components.Hero
            source={{ uri: selectedBenefit.thumbnail_img }}
            backgroundColor={selectedBenefit.theme.backgroundColor}
          />
          <View
            style={[
              { padding: 16, backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'] },
              !isBenefitScreenPresentedAsModal && {
                borderBottomLeftRadius: 16,
                borderBottomRightRadius: 16,
              },
            ]}
          >
            <Components.Title title={selectedBenefit.title} />
            <Components.Summary summary={selectedBenefit.summary} />

            {/* Benefits List */}
            <View style={{ marginVertical: 16 }}>
              {selectedBenefit.benefits.map((benefit) => (
                <View
                  key={benefit}
                  style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}
                >
                  <Check
                    height={20}
                    width={20}
                    color={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
                  />
                  <Text
                    style={{
                      fontFamily: fontFamilies['PlusJakartaSans-Regular'],
                      fontSize: 16,
                      color: mesaColorNames['Mesa - Brand/Blackish #222222'],
                      marginLeft: 12,
                    }}
                  >
                    {benefit}
                  </Text>
                </View>
              ))}
            </View>

            <Button
              testID="get-instacart-today"
              containerStyle={{ marginTop: 24, paddingHorizontal: 16 }}
              buttonStyle={{
                backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
              }}
              onPress={handleGetInstacartPress}
              loading={instacartBenefitUrlResult.isLoading}
              disabled={instacartBenefitUrlResult.isLoading || !instacartUrl}
            >
              <Text
                style={{
                  fontFamily: fontFamilies['PlusJakartaSans-Bold'],
                  fontWeight: 700,
                  fontSize: 16,
                  color: mesaColorNames['Mesa - Brand/Blackish #222222'],
                }}
              >
                Get Instacart+ Today
              </Text>
            </Button>
          </View>

          <Components.Terms terms={selectedBenefit.terms} />
        </Components.Scroll>
      </Components.Container>
    </BenefitModal>
  )
}
